<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Customer config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <h5>Customer Ident</h5>
      <mat-form-field>
        <mat-select placeholder="Customer Ident Link Template" formControlName="customerIdentTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div style="text-decoration: line-through;" class="obsolete">
        <h5>IDV</h5>

        <mat-form-field>
          <mat-select placeholder="IDV link template" formControlName="idvTemplateId">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="IDV success template" formControlName="idvSuccessTemplateId">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-select placeholder="IDV failed template" formControlName="idvFailedTemplateId">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>


      <h5>Revocation</h5>
      <mat-form-field>
        <mat-select placeholder="Revocation Confirmation" formControlName="revocationConfirmationTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Docs</h5>

      <mat-form-field>
        <mat-select placeholder="Docs link template" formControlName="docsTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Docs payment link template" formControlName="docsPaymentTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field>
        <mat-select placeholder="Docs success template" formControlName="docsSuccessTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Docs failed template" formControlName="docsFailedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>SOF Generic</h5>

      <mat-form-field>
        <mat-select placeholder="SOF generic template" formControlName="sofGenericTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field>
        <mat-select placeholder="SOF generic success template" formControlName="sofGenericSuccessTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="SOF generic failed template" formControlName="sofGenericFailedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>SOF Single</h5>

      <mat-form-field>
        <mat-select placeholder="SOF Single template" formControlName="sofSingleTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="SOF Single success template" formControlName="sofSingleSuccessTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="SOF Single failed template" formControlName="sofSingleFailedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Address</h5>

      <mat-form-field>
        <mat-select placeholder="Address confirm link template" formControlName="addressConfirmTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Address change link template" formControlName="addressChangeTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Address success template" formControlName="addressSuccessTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Address failed template" formControlName="addressFailedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>SEPA</h5>
      <mat-form-field>
        <mat-select placeholder="Sepa import template" formControlName="sepaImportTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Change E-Mail</h5>
      <mat-form-field>
        <mat-select placeholder="Change e-mail confirmation template" formControlName="changeEmailTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Bank Transfer Loads</h5>
      <mat-form-field>
        <mat-select placeholder="BTL successful load template" formControlName="btlSuccessLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL successful partial load template" formControlName="btlSuccessPartialLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL Declined load template" formControlName="btlDeclinedLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="BTL pending load template" formControlName="btlPendingLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="BTL load below minimum template" formControlName="btlPendingBelowMinLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL Web ID load template" formControlName="btlWebIdLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="BTL Docs load template" formControlName="btlDocLoadTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="BTL First Load Completed" formControlName="firstBtlCompletedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Locked - overdue invoice</h5>

      <mat-form-field>
        <mat-select placeholder="Cards locked - overdue invoice" formControlName="cardsLockedInvoiceOverdueTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <h5>Re-Order pending</h5>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending No Ident" formControlName="reorderPendingNoIdentTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending Address Unconfirmed" formControlName="reorderPendingAddressUnconfirmedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Re-Order Pending Unpaid Invoice" formControlName="reorderPendingUnpaidInvoiceTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <h5>Happy Birthday 🎉</h5>

      <mat-form-field>
        <mat-select placeholder="Happy Birthday" formControlName="happyBirthdayTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
